<template>
  <div
    class="modal fade colored-header colored-header-primary"
    id="mod-update-order-caution"
    role="dialog"
  >
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-body p-4">
          <h4 class="text-center">
            You're about to update order with order number:
            {{ orderNumber }}
          </h4>
        </div>
        <div
          class="modal-footer d-flex justify-content-center align-items-center"
        >
          <button class="btn btn-danger" type="button" data-dismiss="modal">
            No, Cancel
          </button>
          <button
            class="btn btn-success"
            type="button"
            @click.prevent="onSubmitClick"
          >
            Yes, Proceed
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "UpdateOrderCaution",
  props: ["orderNumber"],

  data() {
    return {
      isDisabled: false,
    };
  },

  created() {
    this.orderId = this.$route.params.id;
  },

  methods: {
    async onSubmitClick() {
      this.$emit("onProceedClick");
    },
  },
};
</script>

<style>
</style>